
import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
import PapaParse from "papaparse";
import { EventBus } from "./../helpers/EventBus";

@Component
export default class Logs extends Vue {
  public isBusy = false;
  public isPagingBusy = false;
  public isRollupBusy = false;
  public dateFrom: string = "";
  public dateTo: string = "";
  public sortBy: string = "When";
  public selectedPredefinedLayout: string = "All";
  public perPage = 20;
  public currentPage = 1;
  public rowCount = 0;
  public selectedColumns: string[] = [];
  public clientStats: any = {}; // Current filtered stats
  public selectedFieldKey:any={};
  public allClientStats: any = {}; // Storing unfiltered options for all columns
  public hostname: string = "";
  public moduleFilters: any = {};

  public allFields = [
    {
      key: "When",
      label: "When",
      sortable: true,
    },
    {
      key: "User",
      label: "User",
      sortable: true,
      showInHeader: true,
    },
    {
      key: "ObjectID",
      label: "Object ID",
      sortable: true,
      showInHeader: false,
    },
    {
      key: "Action",
      label: "Action",
      sortable: true,
      showInHeader: true,
    },
    {
      key: "ObjectType",
      label: "Object Type",
      sortable: true,
      showInHeader: true,
    },
    {
      label: "Src IP",
      key: "SourceInternetAddress",
      sortable: true,
      showInHeader: true,
    },
    {
      key: "Referrer",
      label: "Referrer",
      sortable: true,
      showInHeader: true,
    },
    {
      key: "UserAgent",
      label: "User Agent",
      sortable: true,
      showInHeader: true,
    },
    {
      key: "Details",
      label: "Details",
      sortable: true,
    },
    {
      key: "Reporter",
      label: "Reporter",
      sortable: true,
      showInHeader: true,
    },
    {
      key: "Module",
      label: "Module",
      sortable: true,
      showInHeader: true,
    },
    {
      key: "Path",
      label: "Path",
      sortable: true,
    },
  ];

  public get filterOptions() {
    return this.hostname === "ers"
      ? ["All", "Ribbons", "Slide-Library", "User-Auth", "Clients", "Custom"]
      : ["All", "GenieBot", "User-Auth", "Clients", "Custom"];
  }

  public userFilterString: string = "";

  public filterOnlyFields: any = {
    User: "",
    ObjectID: "",
    Action: "",
    ObjectType: "",
    SourceInternetAddress: "",
    Referrer: "",
    UserAgent: "",
    Reporter: "",
    Module: "",
  };

  public kSelectedColumnsAll = this.allFields.map((x) => x.key);
  public kSelectedColumnsRibbon = [
    "When",
    "User",
    "Action",
    "UserAgent",
    "Details",
  ];
  public kSelectedColumnsSlideLibrary = [
    "When",
    "User",
    "Action",
    "Path",
    "UserAgent",
  ];
  public kSelectedColumnsUserAuth = [
    "When",
    "User",
    "Action",
    "ObjectType",
    "SourceInternetAddress",
    "Details",
  ];
  public kSelectedColumnsGenieBot = [
    "When",
    "User",
    "Action",
    "ObjectType",
    "SourceInternetAddress",
    "Details",
  ];
  public kSelectedColumnsClients = [
    "When",
    "User",
    "SourceInternetAddress",
    "UserAgent",
  ];

  public allColumns = this.allFields.map((x) => {
    return {
      value: x.key,
      text: x.key,
    };
  });

  public get fields() {
    const fields: any = [];
    if (this.allFields) {
      this.allFields.forEach((fi) => {
        if (this.selectedColumns.includes(fi.key)) {
          fields.push(fi);
        }
      });
    }
    return fields;
  }

  public pageOptions = [5, 10, 15];
  public logs: any[] = [];
  public expandAllDetails = false;

  public created() {
    const today = moment();
    const tomorrow = moment(today).add(1, "days");
    this.dateFrom = today.toISOString();
    this.dateTo = tomorrow.toISOString();

    this.allFields.forEach((f) => {
      this.moduleFilters[f.key] = "";
    });
  }

  public mounted() {
    this.hostname = Vue.prototype.$hostMode;
    EventBus.$on("mode-changed", this.modeChanged);
    this.selectedPredefinedLayoutChanged_();
    document
      .querySelectorAll(".table-container")
      .forEach((el) => el.addEventListener("scroll", this.tableFixHead));
      
    // Load initial unfiltered options data
    this.loadAllFilterOptions();
  }

  // Method to load all filter options once at the beginning
  public loadAllFilterOptions() {
    const filter = this.getFilters_(0, 0, false);
    const rollupParams = this.getRollupParams();
    
    axios
      .get(`/api/v4/Logs/Count?${filter}${rollupParams}`)
      .then((response) => {
        
        
        this.allClientStats = Object.keys(response.data.rollups).reduce((acc, key) => {
          if (this.selectedFieldKey.includes(key)) {
            acc[key] = this.allClientStats[key] || response.data.rollups[key];
          } else {
            // Update other fields with new data
            acc[key] = response.data.rollups[key];
          }
          return acc;
        }, {});


        //this.allClientStats = response.data.rollups;
        // Initial load of data to clientStats
        this.clientStats = { ...this.allClientStats };
      });
  }

  public modeChanged(mode) {
    this.hostname = mode;
    this.selectedPredefinedLayoutChanged_();
  }

  public beforeDestroy() {
    EventBus.$off("mode-changed", this.modeChanged);
  }

  public updateClientStats(r) {
    if (!r) {
      this.clientStats = {};
    } else {
      // Only update the clientStats, but preserve allClientStats
      this.clientStats = r;
    }
  }

  public tableSortCompare(a, b, key) {
    if (key === "When") {
      // Assuming the date field is a `Date` object, subtraction
      // works on the date serial number (epoch value)
      const t1 = new Date(a[key]).getTime();
      const t2 = new Date(b[key]).getTime();
      return t1 - t2;
    } else {
      // Let b-table handle sorting other fields (other than `date` field)
      return false;
    }
  }

  public async doDownload() {
    this.isBusy = true;
    const filter = this.getFilters_(0, 0, false);
    const ctx = this.$refs.displayTable as any;

    const sortBy = `&sortBy=${ctx.sortBy}&sortDirection=${
      ctx.sortDesc ? "descending" : "ascending"
    }`;

    const dataToDownload = await axios
      .get(`/api/v4/Logs?${filter}${sortBy}`)
      .then(
        (response) => {
          this.isBusy = false;
          return response.data;
        },
        (error) => {}
      );

    const delimiter = String.fromCharCode(9);

    /*
     * Construct useData form this.logs and filters, to correspond to just what we want to export
     * (til we learn how to read back from table which is doing the same thing).
     */
    const useData: any[] = [];
    if (!dataToDownload) {
      return;
    }
    dataToDownload.forEach((row) => {
      const newR: any = {};
      this.selectedColumns.forEach((c) => {
        newR[c] = row[c];
      });
      useData.push(newR);
    });

    let csv = PapaParse.unparse(useData, {
      delimiter,
    });

    // Document separator format so Excel doesn't prompt user for separator
    csv = "SEP=" + delimiter + "\r\n" + csv;
    const blobData = new Blob([csv]);
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blobData, "ERS exported log data.csv");
    } else {
      const url = window.URL.createObjectURL(blobData);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `ERS exported log data.csv`);
      document.body.appendChild(link);
      link.click();
    }
  }

  public onFiltered(filteredItems) {
    this.rowCount = filteredItems.length;
    this.currentPage = 1;
  }

  @Watch("dateFrom", {
    immediate: false,
    deep: false,
  })
  public dateFromChanged(val: string, oldVal: string) {
    if (oldVal === "") {
      return;
    }
    this.loadAllFilterOptions();
    this.refreshTable();
  }

  @Watch("dateTo", {
    immediate: false,
    deep: false,
  })
  public dateToChanged(val: string, oldVal: string) {
    if (oldVal === "") {
      return;
    }
    this.loadAllFilterOptions();
    this.refreshTable();
  }

  @Watch("expandAllDetails", {
    immediate: false,
    deep: false,
  })
  public expandAllDetailsChanged(val: boolean, oldVal: boolean) {
    this.logs.forEach((r) => {
      r._showDetails = val;
    });
  }

  @Watch("filterOnlyFields", {
    immediate: false,
    deep: true,
  })
  public filterOnlyFieldsChange(val: any, oldVal: any) {
    this.loadAllFilterOptions();
    this.refreshTable();
  }

  // Method to handle filter selection
  public selectFilterValue(key: string, value: string) {
    this.filterOnlyFields[key] = value;
    this.refreshTable();
  }

  // Method to get all available filter options for a given field
  public getFilterOptions(key: string) {
    return this.allClientStats[key] || [];
  }

  public customFormatter(date) {
    return moment(date)
      .toISOString()
      .split("T")[0];
  }

  public tableFixHead(e) {
    const el = e.target;
    const sT = el.scrollTop;
    el.querySelectorAll("thead th").forEach(
      (th) => (th.style.transform = `translateY(${sT}px)`)
    );
  }
  
  public rowSelected(row) {
    row._showDetails = !row._showDetails;
  }

  // New methods for dynamic dropdown sizing
  public getDropdownMenuClass(key: string): string {
    const optionCount = this.getFilterOptions(key).length;
    if (optionCount <= 5) return 'small-menu';
    if (optionCount <= 10) return 'medium-menu';
    return 'large-menu';
  }

  public getOptionContainerHeight(key: string): string {
    const optionCount = this.getFilterOptions(key).length;
    if (optionCount <= 5) return 'auto';
    if (optionCount <= 10) return '180px';
    return '180px';
  }

  public getDropdownItemWidth(option: string): string {
    // Base width + additional width for longer text
    const baseWidth = 150;
    const extraWidth = Math.min(option.length * 5, 150); // Max 150px extra
    return `${baseWidth + extraWidth}px`;
  }

  public getOptionCount(option: string, key: string): number {
    // If you have counts per option, implement that logic here
    // Otherwise just return 1
    return 1;
  }

  public formatCountAndLabel(field: any): string {
    const currentValue = this.filterOnlyFields[field.key];
    const optionCount = this.getFilterOptions(field.key).length;
    const label = optionCount === 1 ? field.label : `${field.label}s`; // Adds 's' for plural
    
    if (currentValue) {
      return `${optionCount} ${label}: ${currentValue}`;
    }
    return `${optionCount} ${label}`;
  }

  private refreshTable() {
    (this.$refs.displayTable as any).refresh();
  }

  private getRollupParams() {
    let result =
      "&rollup=User&rollup=UserAgent&rollup=SourceInternetAddress&rollup=ObjectType&rollup=Action&rollup=Referrer&rollup=Module&rollup=Reporter";
    return result;
  }

  private loadLogs_(limit = 20, skip = 0, sortBy = "") {
    this.isBusy = true;
    const filter = this.getFilters_(limit, skip);
    const rollupParams = this.getRollupParams();
    this.isPagingBusy = true;
    this.isRollupBusy = true;

    axios
      .get(`/api/v4/Logs/Count?${filter}${rollupParams}`)
      .then((response) => {
        this.isRollupBusy = false;
        this.updateClientStats(response.data.rollups);
      });

    axios.get(`/api/v4/Logs/Count?${filter}`).then((response) => {
      this.isPagingBusy = false;
      this.rowCount = parseInt(response.data.count, 10);
    });

    return axios.get(`/api/v4/Logs?${filter}${sortBy}`).then(
      (response) => {
        let id = 0;

        response.data.forEach((e) => {
          let summary = "";
          for (const k of Object.keys(e)) {
            const v = e[k];
            summary += `<span class="log-detail-summary"><b>${k}:</b> ${v}</span>`;
            e.searchString += v;
          }
          e._id = id;
          e.FullItemSummary = summary;
          e._showDetails = false;
          e.When = new Date(e.When).toLocaleString();
          id++;
        });
        this.logs = response.data;
        this.isBusy = false;
        return this.logs;
      },
      (error) => {}
    );
  }

  private getFilters_(limit, skip, paginate = true) {
    const dFrom = this.customFormatter(this.dateFrom);
    const dTo = this.customFormatter(this.dateTo);
    const paginationFilter = paginate ? `limit=${limit}&skip=${skip}&` : "";

    let filter = `${paginationFilter}filter-After=${dFrom}&filter-Before=${dTo}`;

    this.selectedFieldKey = [];
    if (this.userFilterString.trim() !== "") {
      filter = `${filter}&filter-Text-Contains="${this.userFilterString}"`;
    }

    for (const k in this.filterOnlyFields) {
      if (
        this.filterOnlyFields.hasOwnProperty(k) &&
        this.filterOnlyFields[k] !== ""
      ) {
        filter = `${filter}&filter-${k}=${this.filterOnlyFields[k]}`;
        this.selectedFieldKey.push(k); 
      }
    }
    return filter;
  }

  private tableProvider(ctx) {
    const skip = (this.currentPage - 1) * this.perPage;
    const sortBy = `&sortBy=${ctx.sortBy}&sortDirection=${
      ctx.sortDesc ? "descending" : "ascending"
    }`;
    return this.loadLogs_(this.perPage, skip, sortBy);
  }

  private deepEquals_(l, r) {
    return JSON.stringify(l) === JSON.stringify(r);
  }

  private clearFilterOnlyFields(refresh = false) {
    for (const k in this.filterOnlyFields) {
      if (this.filterOnlyFields.hasOwnProperty(k)) {
        this.filterOnlyFields[k] = "";
      }
    }
    this.allFields.forEach((f) => {
    this.moduleFilters[f.key] = "";
  });

    if (refresh) {
      this.refreshTable();
      this.selectedPredefinedLayout = "All";
    }
  }

  private async selectedPredefinedLayoutChanged_() {
    this.sortBy = "When";

          this.clearFilterOnlyFields();

    switch (this.selectedPredefinedLayout) {
      case "All":
        this.selectedColumns = this.kSelectedColumnsAll;
        break;
      case "Ribbons":
        this.selectedColumns = this.kSelectedColumnsRibbon;
        this.filterOnlyFields.Reporter = "OfficeAddin";
        this.filterOnlyFields.Module = "Ribbon";
        break;
      case "Slide-Library":
        this.selectedColumns = this.kSelectedColumnsSlideLibrary;
        this.filterOnlyFields.Reporter = "OfficeAddin";
        this.filterOnlyFields.Module = "SlideLibrary";
        break;
      case "User-Auth":
        this.selectedColumns = this.kSelectedColumnsUserAuth;
        this.filterOnlyFields.Reporter = "WebServer";
        this.filterOnlyFields.Module = "Authorization";
        break;
      case "GenieBot":
        this.selectedColumns = this.kSelectedColumnsGenieBot;
        this.filterOnlyFields.Reporter = "Genie Bot";
        break;
      case "Clients":
        this.selectedColumns = this.kSelectedColumnsClients;
        this.sortBy = "UserAgent";
        break;
    }
    
    // After layout change, reload filter options
    this.loadAllFilterOptions();
  }
  public getSelectedValueTooltip(key: string): string {
  if (this.filterOnlyFields[key]) {
    return `Selected: ${this.filterOnlyFields[key]}`;
  }
  return 'Click to select filter';
}
}
